import { compose } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues, change } from "redux-form";
import { createHocBase } from "app/utils";
import * as actions from "./actions";

const selectProposalState = (state, props) => {
  const proposals = state.proposals;
  const proposal = proposals.proposalsById[props.proposalId];
  return {
    proposals,
    proposal
  };
};

const createProposalActions = dispatch => bindActionCreators(actions, dispatch);

const fetchConditional = props => {
  const { proposal, proposalId, fetchProposal } = props;
  if (proposalId && !proposal) {
    fetchProposal({ proposalId });
  }
};

export const fetchProposal = Component =>
  class extends createHocBase(Component) {
    componentDidMount() {
      fetchConditional(this.props);
    }
    componentDidUpdate({ proposalId }) {
      if (proposalId === this.props.proposalId) return;
      fetchConditional(this.props);
    }
  };

export const connectProposalState = connect(selectProposalState);

export const connectProposalActions = connect(
  null,
  createProposalActions
);

export const withProposals = compose(
  connectProposalState,
  connectProposalActions,
  fetchProposal
);

const selectTmpFieldState = state => {
  const formValues = getFormValues("proposal")(state);
  const tmp = (formValues && formValues.tmp) || {};
  const tmpField = tmp.id ? tmp[tmp.id] : undefined;
  return {
    tmpField
  };
};

const createTmpFieldActions = dispatch => ({
  resetTmpField: () => dispatch(change("proposal", "tmp", {})),
  setTmpField: values => dispatch(change("proposal", "tmp", values))
});

export const withTmpField = compose(
  connect(
    selectTmpFieldState,
    createTmpFieldActions
  )
);



// WEBPACK FOOTER //
// ./src/app/proposals/hocs.js